<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="400px" lazy>
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("length") }}</span>
                </v-card-title>

                <v-divider></v-divider>
                <v-tabs>
                    <v-tab>{{ $t("singleValue") }}</v-tab>
                    <v-tab-item>
                        <v-card-text style="max-height: 180px; overflow-y: auto;">
                            <v-container grid-list-md py-0>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="length"
                                            :label="`${$t('lengthM')} *`"
                                            required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <small>{{ $t("requiredFieldPointer") }}</small>
                        </v-card-text>
                    </v-tab-item>
                    <v-tab>{{ $t("rangeOfValues") }}</v-tab>
                    <v-tab-item>
                        <v-card-text style="max-height: 200px; overflow-y: auto;">
                            <v-container grid-list-md py-0>
                                <v-layout wrap >
                                    <v-flex xs6 class="pb-0 mb-0">
                                        <v-text-field
                                            v-model="valueFrom"
                                            :label="`${$t('initialValue')}, ${$t('m')} *`"
                                            required>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs6 class="pb-0 mb-0">
                                        <v-text-field
                                            v-model="valueTo"
                                            :label="`${$t('finalValue')}, ${$t('m')} *`"
                                            required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap >
                                    <v-flex xs6 class="pt-0 mt-0">
                                        <v-text-field
                                            v-model="step"
                                            :label="`${$t('step')}, ${$t('m')} *`"
                                            required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <small>{{ $t("requiredFieldPointer") }}</small>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs>
                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="saveDataClick">{{ $t("save") }}</v-btn>
                    <v-btn color="error" @click="cancelClick">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "EditLengthDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog:      false,
                dataUpdated: false,
                length:      "",
                lengths:     [],
                saveData:    false,
                valueFrom:   "",
                valueTo:     "",
                step:        0.3
            }
        },

        methods: {
            /**
             * Сброс параметров формы
             */
            resetForm () {
                this.length    = "";
                this.valueFrom = "";
                this.valueTo   = "";
            },

            /**
             * Обработчик нажатия кнопки отмены
             */
            cancelClick () {
                this.saveData = false;
                this.dialog   = false;
            },

            /**
             * Обработчик нажатия кнопки сохранения
             */
            saveDataClick () {
                /*
                let alreadyExists = false;
                this.lengths.forEach(element => {
                    if (element.len == this.length) {
                        alreadyExists = true
                    }
                });

                if (this.length == "") {
                    this.showMessageBox(this.$t("error"), this.$t("valueCantBeEmpty"));
                    return;
                } else if (alreadyExists) {
                    this.showMessageBox(this.$t("error"), this.$t("valueAlreadyExists"));
                    return;
                }

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}lengths/`,
                    data: {
                        Ln: this.length == "" ? 0 : this.length * 1000
                    },
                    withCredentials: true
                }).then(response => {
                    this.dataUpdated = true;
                }).catch(error => {
                    this.showMessageBox(this.$t("error"), this.$t("cantCreateLength"));
                });
                */

                this.saveData = true;
                this.dialog   = false;
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            /*
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
            */
        }
    }
</script>
